import { render, staticRenderFns } from "./ChatbotTemplate.vue?vue&type=template&id=617e1284&scoped=true&"
import script from "./ChatbotTemplate.vue?vue&type=script&lang=js&"
export * from "./ChatbotTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotTemplate.vue?vue&type=style&index=0&id=617e1284&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617e1284",
  null
  
)

export default component.exports